// extracted by mini-css-extract-plugin
module.exports = {"c-prose":"Prose_c-prose___MuFk"};